<mat-toolbar class="mt-10" style="min-height: 40px; max-height: 40px;">
  <div class="absolute right-64">
    <span class="f-s-12 p-r-16">Oregon Health Authority</span>
    <a class="f-s-12 p-r-16" href="#" target="_blank" rel="noreferrer noopener">
      Indoor Clean Air Act
    </a>
    <span class="f-s-12">
      {{environment.build}} Version {{environment.version}}
    </span>
    <!-- <a class="f-s-12 p-r-16" target="_blank" (click)="gotoPage('accessibilityNotice')"> 
      Accessibility
    </a> -->
 </div>
</mat-toolbar>
